'use strict';

function applyDeviceOptions(target) {
  // DEVICE

  /**
   * @prop {string} [device.id]
   * Unique identifyer of the device. If set it will consider the value as the device id.
   * By default, the plugin tries to generate a unique id based on exposed information on the browser.
   * It won't be sent if 'device.isAnonymous option' is set to true.
   */
  target['device.id'] = undefined;

  /**
   * @prop {string} [device.code]
   * Youbora's device code. If specified it will rewrite info gotten from user agent.
   * See a list of codes in {@link http://mapi.youbora.com:8081/devices}
   */
  target['device.code'] = undefined;

  /**
   * @prop {string} [device.model]
   * Device model name
   */
  target['device.model'] = undefined;

  /**
   * @prop {string} [device.brand]
   * Device vendor name
   */
  target['device.brand'] = undefined;

  /**
   * @prop {string} [device.type]
   * Device type (pc, smartphone, stb, tv, etc.)
   */
  target['device.type'] = undefined;

  /**
   * @prop {string} [device.name]
   * Device name. It must exist in NPAW database.
   */
  target['device.name'] = undefined;

  /**
   * @prop {string} [device.osName]
   * OS name.
   */
  target['device.osName'] = undefined;

  /**
   * @prop {string} [device.osVersion]
   * OS version.
   */
  target['device.osVersion'] = undefined;

  /**
   * @prop {string} [device.browserName]
   * Browser name.
   */
  target['device.browserName'] = undefined;

  /**
   * @prop {string} [device.browserVersion]
   * Browser version.
   */
  target['device.browserVersion'] = undefined;

  /**
   * @prop {string} [device.browserType]
   * Browser type.
   */
  target['device.browserType'] = undefined;

  /**
   * @prop {string} [device.browserEngine]
   * Browser engine.
   */
  target['device.browserEngine'] = undefined;

  /**
   * @prop {string} [device.EDID]
   * Connected screen EDID.
   * The expected format is a hex value
   */
  target['device.EDID'] = undefined;

  /**
   * @prop {bool} [device.isAnonymous]
   * If true, it blocks 'deviceUUID' parameter in requests.
   */
  target['device.isAnonymous'] = false;
}

module.exports = applyDeviceOptions;

